module.exports = __webpack_public_path__ + "img/SylviaRhue.3e68e555.png";